/**
 *
 * Formats seconds to mm:ss (Ex. 10:05)
 * @param time Seconds total to format
 *
 */
export const fancyTimeFormat = time => {
	time = Math.round(time);

	// Hours, minutes and seconds
	var hrs = ~~(time / 3600);
	var mins = ~~((time % 3600) / 60);
	var secs = ~~time % 60;

	// Output like "1:01" or "4:03:59" or "123:03:59"
	var ret = "";

	if (hrs > 0) {
		ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
	}

	ret += "" + mins + ":" + (secs < 10 ? "0" : "");
	ret += "" + secs;
	return ret;
};



// WEBPACK FOOTER //
// ./src/utils/timeHelpers.js